import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';

import SaveIcon from '@mui/icons-material/Save';
import { isEmpty } from 'lodash';
import {
  Box,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  TextField,
  Select
} from '@mui/material';
import { withTracker } from 'meteor/react-meteor-data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DriveFolderUploadOutlinedIcon from '@mui/icons-material/DriveFolderUploadOutlined';
import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';

const MapsAdvancedGeneralSettingsField = props => {
  const {
    listComponentsAdvanced,
    setListComponentsAdvanced,
    settingsAdvanced,
    setSettingsAdvanced,
    serverConnection
  } = props;

  const [nameComponent, setNameComponent] = React.useState(
    listComponentsAdvanced.FileToolsComponent.name
  );
  const urlToUploadInitial = settingsAdvanced.fileTools.urlToUpload
    ? settingsAdvanced.fileTools.urlToUpload
    : '';

  const serverConnectionInitial = settingsAdvanced.fileTools.serverConnection
    ? settingsAdvanced.fileTools.serverConnection
    : {};

  const geojsonFunctionInitial = settingsAdvanced.fileTools.geojsonFunction
    ? settingsAdvanced.fileTools.geojsonFunction
    : false;

  const [urlToUpload, setUrlToUpload] = React.useState(urlToUploadInitial);
  const [openModal, setOpenModal] = React.useState(false);
  const [iconFontawesome, setIconFontawesome] = React.useState(
    listComponentsAdvanced.FileToolsComponent.iconFontawesome
  );
  const [iconSvg, setIconSvg] = React.useState(listComponentsAdvanced.FileToolsComponent.iconSvg);
  const [libraryIcon, setLibraryIcon] = React.useState(
    listComponentsAdvanced.FileToolsComponent.libraryIcon
  );
  const [serverSelected, setServerSelected] = React.useState(serverConnectionInitial);
  const [geojsonFunctionState, setGeojsonFunctionState] = React.useState(geojsonFunctionInitial);

  const handleIconSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setIconFontawesome(elementIcon);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        FileToolsComponent: {
          name: listComponentsAdvanced.FileToolsComponent.name,
          show: listComponentsAdvanced.FileToolsComponent.show,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
    }

    if (library === LIBRARY_ICON_TYPES.SVG) {
      setIconSvg(elementIcon.url);
      setIconFontawesome(elementIcon.name);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        FileToolsComponent: {
          name: listComponentsAdvanced.FileToolsComponent.name,
          show: listComponentsAdvanced.FileToolsComponent.show,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
    }
    setLibraryIcon(library);
  };

  return (
    <Box display="flex" width="100%">
      <Box display="column" width="50%" gab={1}>
        <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
          <TextField
            id="outlined-required"
            label="Nombre del componente"
            size="small"
            value={nameComponent}
            onChange={event => setNameComponent(event.target.value)}
            mb={2}
            fullWidth
          />
          <IconButton
            onClick={() => setOpenModal(true)}
            style={{
              color: '#2A3F90'
            }}
          >
            {!isEmpty(libraryIcon) ? (
              <>
                {libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                  <FontAwesomeIcon icon={iconFontawesome} />
                )}
                {libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                  <img
                    src={iconSvg}
                    alt={iconFontawesome}
                    style={{ marginRight: '5px', width: '20px', height: '20px' }}
                  />
                )}
              </>
            ) : (
              <DriveFolderUploadOutlinedIcon />
            )}
          </IconButton>
          <IconButton
            onClick={() =>
              setListComponentsAdvanced({
                ...listComponentsAdvanced,
                FileToolsComponent: {
                  name: nameComponent,
                  show: listComponentsAdvanced.FileToolsComponent.show
                }
              })
            }
            style={{
              color: '#2A3F90'
            }}
          >
            <SaveIcon />
          </IconButton>
          <ShowListIconsFontawesome
            openModal={openModal}
            setOpenModal={setOpenModal}
            handleIconSelected={handleIconSelected}
            selectedIcon={listComponentsAdvanced.FileToolsComponent.iconFontawesome}
            startLibrary={listComponentsAdvanced.FileToolsComponent.libraryIcon}
            svg={listComponentsAdvanced.FileToolsComponent.iconSvg}
            startCategorySvg={listComponentsAdvanced.FileToolsComponent.cetegorySvg}
          />
        </Box>
        <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
          <TextField
            id="outlined-required"
            label="Url"
            size="small"
            value={urlToUpload}
            onChange={event => {
              setUrlToUpload(event.target.value);
              setSettingsAdvanced({
                ...settingsAdvanced,
                fileTools: {
                  geojsonFunction: geojsonFunctionState,
                  urlToUpload: event.target.value,
                  serverConnection: serverSelected
                }
              });
            }}
            mb={2}
            fullWidth
          />
        </Box>
        <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
          <Checkbox
            checked={geojsonFunctionState}
            onChange={() => {
              setGeojsonFunctionState(!geojsonFunctionState);
              setSettingsAdvanced({
                ...settingsAdvanced,
                fileTools: {
                  geojsonFunction: !geojsonFunctionState,
                  urlToUpload,
                  serverConnection: serverSelected
                }
              });
            }}
            sx={{
              color: '#2A3F90',
              '&.Mui-checked': {
                color: '#2A3F90'
              }
            }}
            value="showVideo"
          />
          Habilitar proceso para mapas de nivel
        </Box>
        {geojsonFunctionState === true && (
          <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
            <FormControl sx={{ width: '50%', mr: 1 }}>
              <InputLabel id="demo-select-label">Conexión IPS</InputLabel>
              <Select
                labelId="demo-select-label"
                id="demo-select"
                label="Conexión IPS"
                size="small"
                value={serverSelected ? serverSelected.name : ''}
                onChange={event => {
                  const serverSelectedSearch = serverConnection.find(
                    element => element.name === event.target.value
                  );
                  setServerSelected(serverSelectedSearch);
                  setSettingsAdvanced({
                    ...settingsAdvanced,
                    fileTools: {
                      urlToUpload,
                      serverConnection: serverSelectedSearch,
                      geojsonFunction: geojsonFunctionState
                    }
                  });
                }}
              >
                {serverConnection.map(item => (
                  <MenuItem key={item.name} value={item.name}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default withTracker(() => {
  const connectionsSub = Meteor.isClient && Meteor.subscribe('telemetryConnections');
  return {
    loading: !connectionsSub.ready(),
    serverConnection: TelemetryConnections.find({ serverType: { $in: ['IGPS'] } }).fetch()
  };
})(MapsAdvancedGeneralSettingsField);
MapsAdvancedGeneralSettingsField.defaultProps = {
  settingsAdvanced: {}
};
MapsAdvancedGeneralSettingsField.propTypes = {
  listComponentsAdvanced: PropTypes.object.isRequired,
  setListComponentsAdvanced: PropTypes.func.isRequired,
  settingsAdvanced: PropTypes.bool,
  setSettingsAdvanced: PropTypes.func.isRequired,
  serverConnection: PropTypes.array.isRequired
};
